import React, { useEffect, useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import {
  UserAddOutlined,
  ClusterOutlined,
  BankOutlined,
  UserOutlined,
  SearchOutlined,
  UserSwitchOutlined,
  UsergroupAddOutlined,
  FileDoneOutlined,
} from '@ant-design/icons';
import { Button, Image, Menu, Space } from 'antd';
import '../../index.css';
import { useAuth } from '../../hooks/useAuth';

function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}

// const menuTree = {
//   title1 : [""]
// }

const items = [
  getItem('Work Flow', 'title1', <ClusterOutlined />, [
    getItem('Account Opening', '/'),
    getItem('Account Modification', '/modification'),
  ]),
  getItem('Customer', 'title2', <UsergroupAddOutlined />, [
    getItem('Individual Trader', '/individual'),
    getItem('Corporate Trader', '/corporate'),
  ]),
  getItem('Trading', 'title3', <BankOutlined />, [
    getItem('Market Watch', '/trading/market-watch'),
    getItem('Share Holding', '/trading/share-holding'),
    getItem('Share Freezing', '/trading/share-freezing'),
    // getItem('Share Splitting', '/trading/share-splitting'),
    getItem('Cash In', '/trading/cash-in'),
    getItem('Add Asset', '/trading/add-asset'),
    getItem('Order Book', '/trading/order-book'),
    getItem('Cancel Book', '/trading/cancel-book'),
    getItem('Trade Book', '/trading/trade-book'),
    getItem('Order Book History', '/trading/order-book-history'),
    getItem('Order Quotation', '/trading/order-quotation'),
    getItem('Place Order', '/trading/place-order'),
    getItem('Block Trade', '/trading/block-trade'),
    getItem('Trade Process', '/trading/trade-process'),
    getItem('Trade Process History', '/trading/trade-process-history'),
    getItem('Settlement', '/trading/settlement'),
    getItem('Share Transfer', '/trading/share-transfer'),
  ]),
  getItem('Corporate Action', 'title4', <FileDoneOutlined />, [
    getItem('Share Splitting', '/corporate-action/share-splitting'),
  ]),
  getItem('Reports', 'title5', <FileDoneOutlined />, [
    getItem('FIX Message Log', '/reports/fix-message-log'),
    getItem('FIX Execution Order Log', '/reports/fix-execution-order-log'),
    getItem('Download Center', '/reports/download-center'),
  ]),
  getItem('Administration', 'title6', <UserAddOutlined />, [
    getItem('User', '/administration'),
    getItem('Security Company', '/administration/security-company'),
  ]),
];

export const Sidenav = () => {
  const navigate = useNavigate();
  const { logout, user } = useAuth();
  const [selectedKeys, setSelectedKeys] = useState([]);
  console.log(user);
  const finalItems =
    user.role === 'ADMIN' ? items : items.filter(item => item.label !== 'Administration');
  console.log(finalItems);
  useEffect(() => {
    setSelectedKeys([window.location.pathname]);
    return () => {
      setSelectedKeys([]);
    };
  }, [window.location.pathname]);

  useEffect(() => {
    console.log(selectedKeys);
    const keys = items.filter(item =>
      item.children.some(element => element.key === selectedKeys[0]),
    );
    console.log('KEYSS ', keys[0]?.key);
    setOpenKeys([keys[0]?.key]);
  }, [selectedKeys]);

  const rootSubmenuKeys = ['title1', 'title2', 'title3', 'title4', 'title5'];

  const [openKeys, setOpenKeys] = useState(['title1']);
  const onOpenChange = keys => {
    const latestOpenKey = keys.find(key => openKeys.indexOf(key) === -1);
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  return (
    <section
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'space-between',
        // alignItems: 'center',
        padding: '0rem',
      }}
    >
      <Space direction="vertical" size={'large'}>
        <Menu
          mode="inline"
          style={{
            border: 'none',
            background: 'transparent',
          }}
          className="ant-menu-submenu-title"
          items={finalItems}
          openKeys={openKeys}
          // openKeys={['title2']}

          onOpenChange={onOpenChange}
          onSelect={({ key }) => {
            navigate(key);
            setSelectedKeys([key]);
          }}
          selectedKeys={selectedKeys}
          // defaultSelectedKeys={window.location.pathname}
          defaultOpenKeys={openKeys}
        />
      </Space>
      {/* <button
        onClick={onSignOut}
        style={{
          textDecoration: 'underline',
          display: 'inline-block',
          color: 'white',
          fontSize: '1.2rem',
          background: 'transparent',
          border: 'none',
          marginTop: '10rem',
          paddingBottom: '2rem',
        }}
      >
        Sign Out
      </button> */}
      <Space
        direction="vertical"
        style={{
          marginTop: '2rem',
        }}
      >
        {/* <NavLink exact to="/home" activeClassName="active-link"> */}
        <Button
          type="default"
          onClick={() => {
            navigate('/profile');
            setSelectedKeys([]);
          }}
          size="large"
          block
          icon={<UserOutlined />}
        >
          Your Profile
        </Button>
        <Button type="dashed" ghost onClick={logout} size="large" block>
          Sign out
        </Button>
      </Space>
    </section>
  );
};
